import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import {useMemo} from 'react';

import {getShowcasedVariant} from '../utils/variants';

export function useShowcasedVariant(variants: Array<ProductVariant>) {
  return useMemo(() => getShowcasedVariant(variants), [variants]);
}
